/**
 * Estado del lightbox por bloque del People Landing: `open(idx)` y el nodo a
 * renderizar. Archivo aparte del componente por react-refresh/only-export-components.
 */
import { useCallback, useState } from 'react';
import { LandingLightbox } from './LandingLightbox';

export function useLightbox(images: string[]) {
  const [index, setIndex] = useState<number | null>(null);
  const open = useCallback((i: number) => setIndex(i), []);
  const close = useCallback(() => setIndex(null), []);
  const node = index !== null && images[index] ? (
    <LandingLightbox images={images} index={index} onIndex={setIndex} onClose={close} />
  ) : null;
  return { open, close, node };
}
